import React, { PureComponent } from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { KeycloakProvider } from "./authentication/keycloak/KeycloakProvider";
import "./App.css";
import AppRoutes from "./AppRoutes";

type AppProps = {
  store: any;
};

/**
 * The base of the app.
 *
 * Provides the main app routes, preloads any necessary app data showing a loading indicator until it has completed
 * successfully and  checks if the user is returning to an existing session in which case it redirects them into the
 * app if they are.
 */
class App extends PureComponent<AppProps> {
  renderApp() {
    return (
      <KeycloakProvider>
        <Router>
          <AppRoutes />
        </Router>
      </KeycloakProvider>
    );
  }

  render() {
    const { store } = this.props;

    return <Provider store={store}>{this.renderApp()}</Provider>;
  }
}

export default App;
